// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3cZRI","range":"MonthRangeSwitch_range__1WYcS","disabled":"MonthRangeSwitch_disabled__19rgc"};